// extracted by mini-css-extract-plugin
export default {"wrapper":"SeparatorV8_wrapper__3UEtl","enabled":"SeparatorV8_enabled__5BlbR","separator":"SeparatorV8_separator__4YUMt","active":"SeparatorV8_active__5uVS8"};